import { render, staticRenderFns } from "./ComBtn.vue?vue&type=template&id=122bb727&scoped=true"
import script from "./ComBtn.vue?vue&type=script&lang=js"
export * from "./ComBtn.vue?vue&type=script&lang=js"
import style0 from "./ComBtn.vue?vue&type=style&index=0&id=122bb727&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122bb727",
  null
  
)

export default component.exports